'use client';

import { BoxCTA } from '@lichtblick/photon/atoms/box-cta/box-cta';
import { Text } from '@lichtblick/photon/atoms/text/text';
import { SolarS } from '@lichtblick/photon/icons/technology/solar-s';
import { useTracker } from '@lichtblick/tracker';
import { buildUrl } from '../../helpers/links';
import type { SolarTeaserType } from '../../types/storyblok';
import { CalculatorLayout } from './calculator-layout';
import styles from './calculator-layout.module.scss';

type SolarTeaserProps = SolarTeaserType & Pick<CalculatorLayout, 'isActionTriggerDisabled'>;

export const SolarTeaser: React.FC<SolarTeaserProps> = ({
  _uid,
  buttonLink,
  buttonText,
  chip,
  headline,
  isActionTriggerDisabled,
  text,
}) => {
  const { trackCustomEvent } = useTracker();

  return (
    <CalculatorLayout
      chip={chip}
      headerColor="DarkOrange"
      headline={headline}
      icon={<SolarS />}
      id={_uid}
      isActionTriggerDisabled={isActionTriggerDisabled}
    >
      <div className={styles['calculator-content']}>
        <Text>{text}</Text>
        <BoxCTA
          as="a"
          data-testid="solar-teaser-button"
          href={buildUrl(buttonLink) ?? ''}
          onClick={() =>
            trackCustomEvent({
              eventName: 'tariff_calculator_show_tariffs',
              customProps: {
                product: 'Solar',
              },
            })
          }
          wide
        >
          {buttonText}
        </BoxCTA>
      </div>
    </CalculatorLayout>
  );
};
